module.exports = __webpack_public_path__ + "static/assets/7222f6f9480e8114d9eee90915e5270b.png";